module.exports = require('./delayResolve')
